export default __webpack_public_path__ + "static/media/fontRoboto900_greek.4719c2ae.woff2";